import * as React from 'react'
import { debounce } from 'throttle-debounce'
import TableDriverViewSessionHistory from '../../containers/drivers/TableDriverViewSessionHistoryOld'
import { IDriverSessionFilters } from '../../types'
import moment, { Moment } from 'moment'
import FloatingForm from '../ui/form/FloatingForm'
import { Datepicker } from '@mobiscroll/react'
interface IDriverSessionTablePaneState {
  filters: IDriverSessionFilters
  filterMessage: string
  fromDateDisplay: string
  toDateDisplay: string
}

interface IDriverSessionTablePaneProps {
  operatorId: string
}

class DriverViewSessionHistoryOld extends React.Component<IDriverSessionTablePaneProps, IDriverSessionTablePaneState> {
  public state: IDriverSessionTablePaneState = {
    filters: {
      search: '',
      operatorId: this.props.operatorId,
      fromDate: moment()
        .startOf('day')
        .subtract(7, 'days')
        .toISOString(),
      toDate: moment()
        .endOf('day')
        .toISOString()
    },
    filterMessage: '',
    fromDateDisplay: moment()
      .startOf('day')
      .subtract(7, 'days')
      .format('MM/DD/YYYY hh:mm'),
    toDateDisplay: moment()
      .endOf('day')
      .format('MM/DD/YYYY hh:mm')
  }

  public searchDriverSessionDebounced = debounce(500, (search: string) => {
    this.setState({ filters: { ...this.state.filters, search } })
  })

  public render() {
    const { operatorId } = this.props
    const { filters, fromDateDisplay, toDateDisplay } = this.state
    const { fromDate, toDate } = filters
    return (
      <FloatingForm fullHeight={true}>
        <div className='form-modal-section full-section'>
          <div>
            <label className='ml1 h5 font-red'>{this.state.filterMessage}</label>
            <div className='flex mb2'>
              <div className='dsh-date-filter-wrapper flex flex-column col-3'>
                <label className='font-grey2 bold h5 mb1'>Filter Driver Session</label>
                <Datepicker
                  controls={['calendar', 'time']}
                  dateFormat='MM/DD/YYYY'
                  inputProps={{
                    className: 'session-history-picker'
                  }}
                  rangeEndLabel='To'
                  rangeStartLabel='From'
                  select='range'
                  value={[moment(fromDateDisplay), moment(toDateDisplay)]}
                  onChange={({ value }) => this.handleChangeDateFilter(value)}
                />
              </div>
              <div className='ml1 col-3 flex items-end'>
                <a
                  href={`http://goin-metabase.us-east-1.elasticbeanstalk.com/question/244?DRIVER_ID=${operatorId}&START_DATE=${fromDate}&END_DATE=${toDate}`}
                  target='_blank'
                >
                  <button className='custom-btn mbsc-green-btn'>Download Session</button>
                </a>
              </div>
            </div>

            <div className='border-top mt2'>
              <TableDriverViewSessionHistory filters={filters} />
            </div>
          </div>
        </div>
      </FloatingForm>
    )
  }

  private searchDriverSession = (e: any) => {
    const search = e && e.target.value ? e.target.value : undefined
    this.searchDriverSessionDebounced(search)
  }

  private handleChangeDateFilter = async (value: Date[]) => {
    const [from, to] = value
    if (moment(from).isValid() && moment(to).isValid()) {
      const fromDate = moment(from)
      const toDate = moment(to)
      this.setState(
        {
          filters: { ...this.state.filters, fromDate: fromDate.format() },
          fromDateDisplay: fromDate.format('MM/DD/YYYY HH:mm')
        },
        () => {
          this.setState({
            filters: { ...this.state.filters, toDate: toDate.format() },
            toDateDisplay: toDate.format('MM/DD/YYYY HH:mm')
          })
        }
      )
    }
  }
}

export default DriverViewSessionHistoryOld



// WEBPACK FOOTER //
// ./src/components/drivers/DriverViewSessionHistoryOld.tsx